// extracted by mini-css-extract-plugin
export var requiredStar = "FieldHeader-module__requiredStar___ssXut";
export var subtitle = "FieldHeader-module__subtitle___3lgQv";
export var title = "FieldHeader-module__title___4Y1gd";
export var titleGroup = "FieldHeader-module__titleGroup___mci4h";
export var titleLabel = "FieldHeader-module__titleLabel___M+zPU";